export const environment = {
  production: false,
  name: 'test',
  endPointWs: 'ws://localhost:8000/ws/chat/',
  endPointApi: 'https://dev.bonafe.com.ar/api',
  endPointApiLogin: 'https://dev.bonafe.com.ar',
  endPointApiThird: 'https://dev.bonafe.com.ar/api/dev',
  endPointLinkingPos: 'https://sandbox.linkingpos.com',
  tokenAccessLinkingPos: 'W16NJvnB1suiPLh4mytjNYAs',
  urlMobile: 'https://mobile.dev.bonafe.com.ar',
};
